module.exports = __webpack_public_path__ + "img/photos_left.8395c4f0.png";